<!--经销商销售数据排行-->
<template>
	<div>
		<h3>经销商销售数据排行</h3>
		<div>
            <div class="lines">
                <el-radio-group v-model="date">
                    <el-radio-button label="本月"></el-radio-button>
                    <el-radio-button label="本年"></el-radio-button>
                </el-radio-group>
                <div :style="{height:'500px',width:'100%'}" ref="eChart1" id="eChart1"></div>
            </div>
		</div>
        <div class="item">
            <el-button type="primary" style="margin-bottom: 15px;">导 出</el-button>
            <el-table border>
                <el-table-column align="center" property="DataId" label="排名"></el-table-column>
                <el-table-column align="center" property="Productcode" label="经销商"></el-table-column>
                <el-table-column align="center" property="Productcode" label="销售数量"></el-table-column>
            </el-table>
        </div>
	</div>
</template>

<script>
import echarts from "echarts";//引入图表
export default {
	data(){
		return {
            date:'本月',
			option1 : {
                tooltip: {
                    trigger: 'axis'
                },
                grid: {
                    left: '3%',
                    right: '4%',
                    bottom: '3%',
                    containLabel: true
                },
                xAxis: {
                    type: 'category',
                    data: ['经销商1', '经销商2', '经销商3', '经销商4', '经销商5', '经销商6', '经销商7','经销商8','经销商9','经销商10','经销商11','经销商12']
                },
                yAxis: {
                    type: 'value',
                    splitLine:'false'
                },
                series: [
                    {
                        name: '销量',
                        type: 'bar',
                        barWidth: '60%',
                        data: [120, 132, 101, 134, 90, 280, 210]
                    }
                ]
            },
            
		};
	},
	mounted : function(){
		var user = JSON.parse(sessionStorage.getItem('user'));
        this.initEcharts()

        var elementResizeDetectorMaker = require("element-resize-detector");//导入
        // 创建实例
        var erd = elementResizeDetectorMaker();
        // 创建实例带参
        var erdUltraFast = elementResizeDetectorMaker({
                        strategy: "scroll", //<- For ultra performance.
                        callOnAdd: true,
                        debug: true
                    });
        //监听id为test的元素 大小变化
        erd.listenTo(document.getElementById("eChart1"), function(element) {
             let  myChart1 = echarts.init(document.getElementById('eChart1'));
             myChart1.resize();
        });
	},
	methods: {
        //初始化
        initEcharts(){
            let  myChart1 = echarts.init(this.$refs.eChart1);
            myChart1.setOption(this.option1); 
        }

	}
}
</script>

<style scoped>
.lines{
    width: 100%;
    background: #f8f8f8;
    padding: 10px;
    margin-bottom: 20px;
}
</style>


// WEBPACK FOOTER //
// src/pages/dealer.vue